<mat-label class="subHeading">Pay Till Age</mat-label>
<div class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="pay_till_age" [maxlength]="2" type="text"  appNumberOnly>
</div>
